import React from 'react';
import styled from 'styled-components';

const Wrap = styled.div`
  padding: 0 5%;
  max-width: 1400px;
  margin: 0 auto;
`;

const Rule = styled.hr`
  border: 0;
  height: 1px;
  border-top: 1px solid #e5e7eb;
  margin: 24px 0 0;
`;

export default function SectionDivider() {
  return (
    <Wrap>
      <Rule />
    </Wrap>
  );
}
